export default __webpack_public_path__ + "static/media/void.d730a44e.glsl";